import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_topics_are_included_win_the_facs_written_6'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_topics_are_included_win_the_facs_written_6',
  name: "Which of the following topics are included within the facility's written policies and procedures for wages and benefits?",
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'WAGE_PAYMENTS',
      text: 'Wage payments',
      externalIds: [
        {
          id: 'ms-1--8-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WAGE_CALCULATIONS',
      text: 'Wage calculations',
      externalIds: [
        {
          id: 'ms-1--8-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'RATES_BY_UNIT',
      text: 'Rates by unit',
      externalIds: [
        {
          id: 'ms-1--8-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OVERTIME_PAY',
      text: 'Overtime pay',
      externalIds: [
        {
          id: 'ms-1--8-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PAID_LEAVE',
      text: 'Paid leave',
      externalIds: [
        {
          id: 'ms-1--8-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ANNUAL_LEAVE',
      text: 'Annual leave',
      externalIds: [
        {
          id: 'ms-1--8-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SICK_LEAVE',
      text: 'Sick leave',
      externalIds: [
        {
          id: 'ms-1--8-7x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MATERNITY_LEAVE',
      text: 'Maternity leave',
      externalIds: [
        {
          id: 'ms-1--8-8x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PATERNITY_LEAVE',
      text: 'Paternity leave',
      externalIds: [
        {
          id: 'ms-1--8-9x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EMERGENCY_FAMILY_LEAVE',
      text: 'Emergency family leave',
      externalIds: [
        {
          id: 'ms-1--8-10x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'BENEFITS',
      text: 'Benefits',
      externalIds: [
        {
          id: 'ms-1--8-11x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'DEDUCTIONS',
      text: 'Deductions',
      externalIds: [
        {
          id: 'ms-1--8-12x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-1--8-13x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-1--8-13f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'WAGE_PAYMENTS',
                'WAGE_CALCULATIONS',
                'RATES_BY_UNIT',
                'OVERTIME_PAY',
                'PAID_LEAVE',
                'ANNUAL_LEAVE',
                'SICK_LEAVE',
                'MATERNITY_LEAVE',
                'PATERNITY_LEAVE',
                'EMERGENCY_FAMILY_LEAVE',
                'BENEFITS',
                'DEDUCTIONS',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-pla-21',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 19390,
  sectionId: '2.2.6.10',
  impactArea: 'Policies and Procedures',
  impactAreaId: 'POLICIES_AND_PROCEDURES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
